<template>
    <span v-if="!isDetail && !params.node.rowPinned">
        <b-button title="Print Invoice" :href="data.receipt_url" variant="default">
            <font-awesome-icon :icon="['fas', 'print']"></font-awesome-icon>
        </b-button>
    </span>
</template>

<script>
    export default {
        created() {
            this.data = this.params.data;
        },
        computed: {
            isDetail() {
                return this.data.payment_type == 'DETAIL';
            },
        },
    };
</script>

<style lang="scss" scoped>
    .ag-row .ag-cell {
        display: flex;
        align-items: start;
    }
</style>
